import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import http_formData from "AppQuries/utils/http_formData";

const getEmpOfferLetters = async ({ companyCode, employeeCode }) => {
  if (!companyCode || !employeeCode) return [];
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetEmployeeOfferLetterList}?CompanyCode=${companyCode}&EmployeeCode=${employeeCode}`
  );
  return data;
};

const getOfferLetterById = async ({ code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.OfferLetterAPI}?isAll=false&code=${code}`
  );
  return data;
};

const insertOfferLetter = async (input) => {
  const { data } = await http_formData.post(Api_EndPoints.CreateOfferLetter, input);
  return data;
};

const updateOfferLetter = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.OfferLetterAPI, input);
  return data;
};

const deleteOfferLetter = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.OfferLetterAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetEmpOfferLettersQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetEmployeeOfferLetterList],
    queryFn: () => getEmpOfferLetters(companyCode),
  });
};

export const useGetOfferLetterByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.OfferLetterAPI],
    queryFn: () => getOfferLetterById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertOfferLetterMutation = () => {
  return useMutation({
    mutationFn: insertOfferLetter,
  });
};

export const useUpdateOfferLetterMutation = () => {
  return useMutation({
    mutationFn: updateOfferLetter,
  });
};

export const useDeleteOfferLetterMutation = () => {
  return useMutation({
    mutationFn: deleteOfferLetter,
  });
};
